"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 animate-pulse rounded-none bg-secondary" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="block w-full max-w-full">
      <NavigationMenuList className="flex-col items-start gap-3 space-x-0 w-full">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild className="w-full justify-start p-0 h-auto bg-transparent hover:bg-transparent hover:text-primary focus:bg-transparent focus:text-primary text-muted-foreground transition-colors font-mono text-xs uppercase tracking-widest">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const impactAreas = ["Commercial Production", "Live Streaming", "Social Content"];
  return <section data-section-id="231181" id="footer" className="bg-background text-foreground pt-16 pb-8 px-4 md:px-8 border-t border-border">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start gap-6">
            <Link to="/HomePage">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658650/img/pivotal_placement_logo_footer.png" alt="Pivotal Placement Logo" className="h-7 w-auto grayscale brightness-200" />
            </Link>
            <p className="text-muted-foreground leading-relaxed font-mono text-sm">
              Cinematic artistry for brands that demand attention. High-quality video production for the digital age.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold text-foreground uppercase tracking-tighter">Navigation</h3>
            <MenuProvider menu_id="42">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold text-foreground uppercase tracking-tighter">Capabilities</h3>
            <ul className="flex flex-col gap-3">
              {impactAreas.map((area, i) => <li key={i} data-index={i}>
                  <Link to="/TheReelPage" className="text-muted-foreground hover:text-primary transition-colors font-mono text-xs uppercase tracking-widest">
                    {area}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold text-foreground uppercase tracking-tighter">Studio</h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 text-muted-foreground font-mono text-xs uppercase tracking-widest">
                <MapPin className="size-5 shrink-0 text-primary mt-0.5" />
                <span>Los Angeles, CA</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-mono text-xs uppercase tracking-widest">
                <Phone className="size-5 shrink-0 text-primary" />
                <span>+1 (555) 012-3456</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-mono text-xs uppercase tracking-widest">
                <Mail className="size-5 shrink-0 text-primary" />
                <span>hello@pivotalplacement.com</span>
              </li>
            </ul>
            
            <div className="flex items-center gap-2 mt-2">
              <Button variant="ghost" size="icon" className="rounded-none hover:text-primary hover:bg-primary/10" asChild>
                <Link to="#" aria-label="Instagram">
                  <Instagram className="size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" className="rounded-none hover:text-primary hover:bg-primary/10" asChild>
                <Link to="#" aria-label="LinkedIn">
                  <Linkedin className="size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" className="rounded-none hover:text-primary hover:bg-primary/10" asChild>
                <Link to="#" aria-label="Facebook">
                  <Facebook className="size-5" />
                </Link>
              </Button>
            </div>
          </div>

        </div>

        {}
        <div className="flex flex-col gap-6">
          <Separator className="bg-border h-px w-full" />
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-mono uppercase tracking-widest text-muted-foreground">
            <p>© {currentYear} Pivotal Placement. All rights reserved.</p>
            <div className="flex items-center gap-6">
              <Link to="#" className="hover:text-primary transition-colors">Privacy</Link>
              <Link to="#" className="hover:text-primary transition-colors">Terms</Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}